import { InstallationcostService } from '../services/installationcost.service';
import { Component, OnInit } from '@angular/core';
import { RecommendationService } from 'app/services/recommendation.service';
import { OfferService } from 'app/services/offer.service';
import { isHK } from 'app/app.component';

@Component({
  selector: 'app-installation-cost',
  templateUrl: './installation-cost.component.html',
  styleUrls: ['./installation-cost.component.css']
})
export class InstallationCostComponent implements OnInit {
  offerent: string;

  constructor(
    private offerService: OfferService,
    private installationcostService: InstallationcostService,
    private recommendationService: RecommendationService) { }

  ngOnInit() {
  }

  getIsHK(): boolean {
    return isHK;
  }

  getMontagePrice() {
    return this.installationcostService.instCost;
  }

  getOfferent() {
    return this.installationcostService.offer.nazwa;
  }
}



// WEBPACK FOOTER //
// /Users/michaldudziak/Desktop/Projekty/Projekt-Sunroof/Sunroof/src/app/installation-cost/installation-cost.component.ts